import { Component, ViewChild, OnInit, OnDestroy } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MasterMakeService } from 'src/app/share/services/master-make/master-make.service';
import { StockService } from 'src/app/share/services/stock/stock.service';
import { faSpinner, faSliders, faAngleDown, faAngleUp, faTriangleExclamation, faCircleExclamation } from '@fortawesome/free-solid-svg-icons';
import { StorageService } from 'src/app/share/services/storage-service/storage.service';
import { StorageKeys } from '../../share/enums/storage.enum';
import { CompanyServiceService } from 'src/app/share/services/company-service/company-service.service';
import dayjs from 'dayjs';
import { DealersService } from 'src/app/share/services/dealers/dealers.service';
import { LedgersService } from 'src/app/share/services/ledgers/ledgers.service';
import { DownloadService } from 'src/app/share/services/download.service';
import { DomSanitizer } from '@angular/platform-browser';
import { NgbDateParserFormatter, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { SdexAdminService } from 'src/app/share/services/sdex/sdex-admin.service';
import { RangeDatePickerComponent } from 'src/app/share/range-date-picker/range-date-picker.component';
import { Router, NavigationStart } from '@angular/router';
import { DayBookService } from 'src/app/share/services/day-book/day-book.service';
import { Subject, Subscription } from 'rxjs';
import { debounceTime, distinctUntilChanged, filter, first } from 'rxjs/operators';

@Component({
    selector: 'app-sku-ledger',
    templateUrl: './sku-ledger.component.html',
    styleUrls: ['./sku-ledger.component.scss'],
    standalone: false
})
export class SkuLedgerComponent implements OnInit, OnDestroy {

  protected faSpinner = faSpinner;
  protected faSliders = faSliders;
  protected faAngleDown = faAngleDown;
  protected faAngleUp = faAngleUp;
  protected faTriangleExclamation = faTriangleExclamation;
  protected faCircleExclamation = faCircleExclamation;

  loader: boolean = false;
  filterLoading: boolean = false;
  isFilterApplied: boolean = false;
  isBranchVisible: boolean = false;
  showFilterPanel: boolean = true;
  showtable: boolean = false;
  isEmptyResult: boolean = false;
  errorMessage: any;
  filterForm: FormGroup;
  showPerformanceScreen: boolean = false;
  customerLoading: boolean = false;
  customSearchFn = () => true;

  heading = {
    label: '',
    main: 'SKU ledger',
    footer: 'Choose date range and apply filter to load transations',
  }
  highlightCards = [
    {
      heading: 'Opening balance',
      value: 0,
      key: 'openingBalance',
    },
    {
      heading: 'Total inward',
      value: 0,
      key: 'totalInward',
    },
    {
      heading: 'Total outward',
      value: 0,
      key: 'totalOutward',
    },
    {
      heading: 'Closing balance',
      value: 0,
      key: 'closingBalance',
    },
  ]
  displayRangeText: string = 'Select Date';
  dateRanges = [
    { label: 'Today', value: 1 },
    { label: 'Last 7 Days', value: 7 },
    { label: 'Last 30 Days', value: 30 },
    { label: 'Last 90 Days', value: 90 }
  ];
  activeDealerId: any;
  tyreSizeList: any[] = [];
  tyreMakeList: any[] = [];
  tyreModelList: any[] = [];
  branchData: any[] = [];
  dealerList: any[] = [];
  customers: any[] = [];
  usersList: any[] = [];
  usersObj: any = { page: 0 };
  customerObj: any = { page: 0 };
  dealerObj: any = { page: 0 };
  tyreSizeObj: any = { page: 0 };
  tyreMakeObj: any = { page: 0 };
  tyreModelObj: any = { };
  selectedVocher: { url: any, name: any } = { url: '', name: '' };
  data: any[] = [];
  page: number = 0;
  endOfTableData: boolean = false;
  showHighlightCards: boolean = false;

  private readonly voucherSearch$ = new Subject<string>();
  private voucherSearchSub: Subscription;
  private filterSub: Subscription;
  private tableSub: Subscription;
  trxTypes = [
    { name: 'Sale', value: 'Sale' },
    { name: 'Purchase', value: 'Purchase' },
    { name: 'Transfer', value: 'Transfer' },
    { name: 'Import', value: 'Import' }
  ];
  sortingFieds: any = {
    date: 0,
  }
  tablePayload: any = {};
  dealerHighlights: any;
  roleList = ['Dealer', 'Customer'];

  @ViewChild('datepicker', { static: false }) datepicker!: any;


  constructor(
    private readonly stockService: StockService,
    private readonly masterMakeService: MasterMakeService,
    private readonly formBuilder: FormBuilder,
    private readonly storageService: StorageService,
    private readonly companyService: CompanyServiceService,
    private readonly dealersService: DealersService,
    private readonly ledgersService: LedgersService,
    private readonly downloadService: DownloadService,
    private readonly sanitizer: DomSanitizer,
    private readonly modalService: NgbModal,
    public readonly formatter: NgbDateParserFormatter,
    private readonly sdexAdminService: SdexAdminService,
    private readonly router: Router,
    private readonly dayBookService: DayBookService
  ) { 
    this.createFilterForm();
    this.setDropDownVisiblity();
  }

  ngOnInit(): void {
    this.router.events.pipe(
      filter(event => event instanceof NavigationStart),
      first()
    ).subscribe((event: any) => {
      const targetUrl = event.url || '';
      if (!targetUrl.includes('day-book')) {
        this.dayBookService.clearSavedDayBookDate();
      }
    });

    this.getTyreSize()
    this.getTyreMake()
    this.getDealers()
    this.getAllUsers();

    this.voucherSearchSub = this.voucherSearch$.pipe(
      debounceTime(500),
      distinctUntilChanged()
    ).subscribe(() => {
      this.onChangeApplyFilter(!this.showFilterPanel);
    });

    if (this.ledgersService.selectedSkuFilter) {
      const filter = this.ledgersService.selectedSkuFilter;
      this.filterForm.patchValue({
        tyreSize: filter.tyreSize,
        tyreMake: filter.tyreMake,
        tyreModel: filter.tyreModel,
        branches: [filter.company],
      });

      this.tyreModelObj.tyreMake = filter.tyreMake;
      this.tyreModelObj.tyreSize = filter.tyreSize;
      this.tyreModelObj.name = '';
      this.tyreModelList = [];
      this.getTyreModel();
      this.isFilterApplied = true;
      this.applyFilter(true);
      this.ledgersService.selectedSkuFilter = null;
    }
  }

  ngOnDestroy(): void {
    if (this.voucherSearchSub) this.voucherSearchSub.unsubscribe();
    if (this.filterSub) this.filterSub.unsubscribe();
    if (this.tableSub) this.tableSub.unsubscribe();
  }

  onVoucherInput(event: Event) {
    const value = (event.target as HTMLInputElement).value;
    this.voucherSearch$.next(value);
  }

  createFilterForm() {
    this.filterForm = this.formBuilder.group({
      created_datefrom: ['', Validators.required],
      created_dateupto: ['', Validators.required],
      tyreSize: [null, Validators.required],
      tyreMake: [null, Validators.required],
      tyreModel: [null, Validators.required],
      branches: [[]],
      transactionTypes: [[]],
      dealers: [[]],
      customers: [[]],
      role: [[]],
      voucher: [''],
      addedBy: [null],
    });
    this.applyDaysRange(30);
  }

  applyDaysRange(days: number) {
    const today = dayjs();
    const start = today.subtract(days - 1, 'day');
    const end = today;
    this.filterForm.patchValue({
      created_datefrom: start.format('YYYY-MM-DD'),
      created_dateupto: end.format('YYYY-MM-DD')
    });
    if (days === 1) this.displayRangeText = 'Today';
    else if (days === 7) this.displayRangeText = 'Last 7 Days';
    else if (days === 30) this.displayRangeText = 'Last 30 Days';
    else if (days === 90) this.displayRangeText = 'Last 90 Days';
    this.onChangeApplyFilter();
  }

  setDropDownVisiblity() {
    let userDetailsData = this.storageService.getDataFromLocalStorage(StorageKeys.SELF_DETAILS);
    this.isBranchVisible = userDetailsData?.enrollmentType === 'Company';
    if (this.isBranchVisible) {
      this.getBranchList();
    }
  }

  getBranchList() {
    this.companyService.getToCompanyList().subscribe((res: any) => {
      let branchData = res.data || [];
      this.branchData = branchData?.filter((company: any) => company.status === 'Active') || [];
    });
  }


  getTyreSize() {
    this.stockService.getTyreDetails(this.tyreSizeObj).subscribe({
      next: (res: any) => {
        if (this.tyreSizeObj.page === 0) {
          this.tyreSizeList = res.data;
        } else {
          this.tyreSizeList = [...this.tyreSizeList, ...res.data]
        }
      },
    });
  }

  scrollTyreSize() {
    this.tyreSizeObj.page++
    this.getTyreSize()
  }

  onSizeClose() {
    if (this.tyreSizeObj.searchTerm) {
      this.tyreSizeObj.page = 0;
      this.tyreSizeObj.searchTerm = '';
      this.getTyreSize();
    }
  }

  onTyreSizeInputChange(event: any) {
    this.tyreSizeObj.page = 0
    let tyreSizeSearch = event.term;
    this.tyreSizeObj.searchTerm = tyreSizeSearch;
    this.tyreSizeList = []
    this.getTyreSize()
  }

  changeTyreSize() {
    let tyreMake = this.filterForm.controls['tyreMake'].value
    let tyreSize = this.filterForm.controls['tyreSize'].value
    if (tyreSize) {
      this.filterForm.controls['tyreModel'].setValue(null);
      if (tyreMake) {
        this.tyreModelObj.tyreMake = tyreMake;
        this.tyreModelObj.tyreSize = tyreSize
        this.tyreModelObj.name = '';
        this.tyreModelList = []
        this.getTyreModel();
      }
    }
  }


  getTyreMake() {
    this.masterMakeService.getTyreMakeBySize(this.tyreMakeObj.page, this.tyreMakeObj.searchTerm).subscribe({
      next: (res: any) => {
        if (this.tyreMakeObj.page === 0) {
          this.tyreMakeList = res.data;
        } else {
          this.tyreMakeList = [...this.tyreMakeList, ...res.data]
        }
      },
    });
  }


  onTyreMakeInputChange(event: any) {
    this.tyreMakeObj.page = 0
    let tyreMakeSearch = event.term;
    this.tyreMakeObj.searchTerm = tyreMakeSearch;
    this.tyreMakeList = []
    this.getTyreMake()
  }

  onMakeClose() {
    if (this.tyreMakeObj.searchTerm) {
      this.tyreMakeObj.page = 0;
      this.tyreMakeObj.searchTerm = '';
      this.getTyreMake();
    }
  }

  onMakeSelected() {
    let option = this.filterForm.controls['tyreMake'].value;
    if (option) {
      this.filterForm.controls['tyreModel'].setValue(null);
      let tyreSize = this.filterForm.controls['tyreSize'].value
      if(tyreSize) {
      this.tyreModelObj.tyreMake = option;
      this.tyreModelObj.tyreSize = tyreSize
      this.tyreModelList = []
      this.getTyreModel()
      }
    }
  }

  getTyreModel() {
    this.ledgersService.getLatestTyreModels(this.tyreModelObj).subscribe({
      next: (res: any) => {
          this.tyreModelList = res.data
      },
    });
  }

  resetSort() {
    this.sortingFieds = {
      date: 0,
    }
  }

  adjustFilter() {
    this.showFilterPanel = true;
    this.isEmptyResult = false;
  }

  resetFormFields() {
    this.resetSort();
    this.filterForm.reset({
      created_datefrom: '',
      created_dateupto: '',
      tyreSize: null,
      tyreMake: null,
      tyreModel: null,
      branches: [],
      transactionTypes: [],
      dealers: [],
      customers: [],
      role: [],
      voucher: '',
      addedBy: null,
    });
    this.showFilterPanel = true;
    this.showHighlightCards = false;
    this.isEmptyResult = false;
    this.isFilterApplied = false;
    this.applyDaysRange(30);
    this.heading.label = '';
    this.heading.main = 'SKU ledger';
    this.heading.footer = 'Choose date range and apply filter to load transations';
    this.data = [];
    this.showtable = false;
  }

  onRoleToggle(role: string) {
    const current: string[] = this.filterForm.get('role')?.value || [];
    const updated = current.includes(role)
      ? current.filter(r => r !== role)
      : [...current, role];
    this.filterForm.get('role')?.setValue(updated);
    this.onChangeApplyFilter();
  }

  onChangeApplyFilter(closePanel: boolean = false) {
    if (this.filterForm.valid && this.isFilterApplied) {
      this.applyFilter(closePanel);
    }
  }

  applyFilter(closePanel: boolean = true,) {
    if (!this.filterForm.valid) return;
    this.resetSort();
    this.filterLoading = true;
    this.loader = true;
    this.page = 0;
    this.endOfTableData = false;
    this.data = [];
    this.tablePayload = this.preparePayload();
    if (this.filterSub) this.filterSub.unsubscribe();
    this.filterSub = this.ledgersService.getSkuLedgerData(this.tablePayload).subscribe({
      next: (res: any) => {
        this.heading.label = 'SKU Ledger';
        this.heading.main = `${this.tablePayload.tyreSize} ${this.tablePayload.tyreMake} ${this.tablePayload.tyreModel}`;
        this.heading.footer = '';
        this.showFilterPanel = !closePanel;
        if (res.data) {
          this.mapResponse(res);
        }
        this.isFilterApplied = true;
        this.filterLoading = false;
      },
      error: (error: any) => {
        this.mapError(error);
        this.resetFormFields();
      }
    })
  }

  preparePayload() {
    let filter: any = { ...this.filterForm.value }
    let tablePayload: any = {
      tyreSize: filter.tyreSize,
      tyreMake: filter.tyreMake,
      tyreModel: filter.tyreModel,
      created_datefrom: filter.created_datefrom,
      created_dateupto: filter.created_dateupto,
      page: this.page,
    }
    if (filter.branches.length) tablePayload.branch_in = filter.branches.toString();
    if (filter.transactionTypes.length) tablePayload.transactionType_in = filter.transactionTypes.toString();
    if (filter.dealers.length) tablePayload.dealer_in = filter.dealers.toString();
    if (filter.customers.length) tablePayload.customer_in = filter.customers.toString();
    if (filter.role.length) tablePayload.role_in = filter.role.toString();
    if (filter.voucher) tablePayload.voucher = filter.voucher;
    if (filter.addedBy) tablePayload.addedBy = filter.addedBy;
    return tablePayload;
  }

  mapResponse(res: any) {
    if (res.data.stockBalance) {
      let stockBalance = res.data.stockBalance;
      this.highlightCards[0].value = stockBalance.openingBalance || 0;
      this.highlightCards[1].value = stockBalance.totalInward || 0;
      this.highlightCards[2].value = stockBalance.totalOutward || 0;
      this.highlightCards[3].value = stockBalance.closingBalance || 0;
      if (stockBalance.openingBalance || stockBalance.totalInward || stockBalance.totalOutward) {
        this.showHighlightCards = true;
      } else {
        this.showHighlightCards = false;
      }
    }

    const openingBalance = res.data.stockBalance?.openingBalance || 0;

    if (res.data.result.length) {
      this.isEmptyResult = false;
      this.heading.footer = `Showing transation from ${this.displayRangeText}`
      this.formatStockData(res.data.result);
      this.showtable = true;
    } else {
      this.data = [];
      this.loader = false;
      if (!this.tablePayload.addedBy && !this.tablePayload.voucher) {
        if (openingBalance === 0) {
          this.showtable = false;
          this.isEmptyResult = true;
        } else {
          this.isEmptyResult = false;
          this.showtable = true;
        }
      }
    }
  }

  mapError(error: any) {
    this.filterLoading = false;
    this.errorMessage = error?.error?.message || "Failed to fetch data";
    this.isFilterApplied = false;
    this.data = [];
    this.showtable = false;
    this.loader = false;
  }

  sortingByField(header: string) {
    this.page = 0;
    this.endOfTableData = false;
    this.data = [];

    const current = this.sortingFieds[header] || 0;
    let nextSort: number;
    if (current === 0) {
      nextSort = 1;
    } else if (current === 1) {
      nextSort = -1;
    } else {
      nextSort = 0;
    }
    this.sortingFieds[header] = nextSort;

    let sortingObj: any = {};
    if (this.sortingFieds[header] !== 0) {
      sortingObj = { sort: header, sortDir: this.sortingFieds[header] };
    }
    this.getLegersTableData(sortingObj);
  }


  getLegersTableData(sort: any = {}) {
    this.loader = true;
    this.tablePayload = {
      ...this.tablePayload,
      ...sort,
      page: this.page,
    }
    if (this.tableSub) this.tableSub.unsubscribe();
    this.tableSub = this.ledgersService.getSkuLedgerData(this.tablePayload).subscribe({
      next: (res: any) => {
        this.formatStockData(res.data.result || []);
      },
      error: (error: any) => {
        this.loader = false;
        this.errorMessage = error?.error?.message || "Failed to fetch data"
      }
    })
  }

  formatStockData(data: any[]) {
    let formatedData = data.map(item => {
      const createdDate = new Date(item.created);
      const formattedDate = createdDate.toLocaleDateString('en-GB', { timeZone: 'Asia/Kolkata', day: '2-digit', month: '2-digit', year: 'numeric' }).replaceAll('/', '-');
      let balance = 0
      balance = item.cumulativeBalance || 0;
      return {
        ...item,
        date: formattedDate,
        type: item.transactionType || '',
        branch: item.companyName || '',
        voucherNo: item.invoiceNumber || '-',
        price: Number.isNaN(Number(item.price)) ? 0 : Number(item.price),
        qty: Number.isNaN(Number(item.quantity)) ? 0 : Number(item.quantity),
        balance: Number.isNaN(Number(balance)) ? 0 : Number(balance),
        outward: item.stockType === 'stockOut',
        neagative: balance < 0,
        dealerId: item.dealerId?._id || '',
      };
    });

    if (this.page === 0) {
      this.data = [{
        date: 'Opening balance',
        balance: this.highlightCards[0].value,
      }]
    }

    this.data = [...this.data, ...formatedData];

    if (data.length !== 20) {
      this.endOfTableData = true;
      let closingBalance = {
        date: 'Closing balance',
        balance: this.highlightCards[3].value,
        last: true,
      }
      this.data = [...this.data, closingBalance];
    }
    this.loader = false;
  }

  onscrollTable() {
    if (!this.endOfTableData && !this.loader) {
      this.page++;
      this.getLegersTableData();
    }
  }


  viewVoucher(data: any, model: any) {
    if (data.invoice) {
      this.selectedVocher.url = this.sanitizer.bypassSecurityTrustResourceUrl(data.invoice);
      this.selectedVocher.name = data.voucherNo;
      this.modalService.open(model, { size: 'lg', centered: true, backdrop: 'static', keyboard: false });
    }
  }

  downloadPdf() {
    let tablePayload: any = { ...this.tablePayload }
    if ('page' in tablePayload) delete tablePayload.page;
    if ('sort' in tablePayload) delete tablePayload.sort;
    if ('sortDir' in tablePayload) delete tablePayload.sortDir;
    const filename = `SKU_Ledger_${dayjs().format('YYYYMMDD_HHmmss')}.pdf`;
    const request = this.ledgersService.getSkuLedgersPdf(tablePayload);
    this.downloadService.download(request, filename);
  }

  downloadExcel() {
    let tablePayload: any = { ...this.tablePayload }
    if ('page' in tablePayload) delete tablePayload.page;
    if ('sort' in tablePayload) delete tablePayload.sort;
    if ('sortDir' in tablePayload) delete tablePayload.sortDir;
    const filename = `SKU_Ledger_${dayjs().format('YYYYMMDD_HHmmss')}.xlsx`;
    const request = this.ledgersService.getSkuLedgersExcel(tablePayload);
    this.downloadService.download(request, filename);
  }

  applyDealerRange(value: any, label: string) {
    if (value === 'all') {
      delete this.dealerHighlights.created_datefrom;
      delete this.dealerHighlights.created_dateupto;
      this.dealerHighlights.displayRangeText = 'All';
      this.fetchDealerSummary();
    } else {
      const days = value;
      const today = dayjs();
      const start = today.subtract(days - 1, 'day');
      const end = today;
      this.dealerHighlights.created_datefrom = start.format('YYYY-MM-DD');
      this.dealerHighlights.created_dateupto = end.format('YYYY-MM-DD');
      this.dealerHighlights.displayRangeText = label;
      this.fetchDealerSummary();
    }
  }

  openDealerCalendar() {
    const modalRef = this.modalService.open(RangeDatePickerComponent, { size: 'lg', centered: true, backdrop: 'static', keyboard: false });
    modalRef.componentInstance.initialFromDate = this.dealerHighlights.created_datefrom || null;
    modalRef.componentInstance.initialToDate = this.dealerHighlights.created_dateupto || null;

    modalRef.result.then((result) => {
      if (result?.fromDate && result?.toDate) {
        this.dealerHighlights.created_datefrom = result.fromDate;
        this.dealerHighlights.created_dateupto = result.toDate;
        this.dealerHighlights.displayRangeText = dayjs(result.fromDate).format('DD-MM-YYYY') + ' - ' + dayjs(result.toDate).format('DD-MM-YYYY');
        this.fetchDealerSummary();
      }
    }, () => { });
  }

  fetchDealerSummary() {
    this.dealerHighlights.loader = true;
    let tablePayload: any = {
      dealer: this.activeDealerId,
      tyreSize: this.tablePayload.tyreSize,
      tyreMake: this.tablePayload.tyreMake,
      tyreModel: this.tablePayload.tyreModel,
    }
    if (this.dealerHighlights.created_datefrom) tablePayload.created_datefrom = this.dealerHighlights.created_datefrom;
    if (this.dealerHighlights.created_dateupto) tablePayload.created_dateupto = this.dealerHighlights.created_dateupto;

    this.ledgersService.getDealerSummary(tablePayload).subscribe({
      next: (res: any) => {
        if (res.data) {
          this.dealerHighlights.totalPurchases = res.data.totalPurchases || 0;
          this.dealerHighlights.minPrice = res.data.minPrice || 0;
          this.dealerHighlights.maxPrice = res.data.maxPrice || 0;
          this.dealerHighlights.averageQuantity = res.data.averageQuantity || 0;
          this.dealerHighlights.lastPurchasePrice = res.data.lastPurchasePrice || 0;
          this.dealerHighlights.loader = false
        } else {
          this.dealerHighlights.loader = false
          this.dealerHighlights.errorMessage = "There is no data available for this dealer"
        }
      },
      error: (error: any) => {
        this.dealerHighlights.loader = false;
        this.dealerHighlights.errorMessage = error?.error?.message || "Failed to get dealer summary"
      }
    })
  }

  openCalendar() {
    const modalRef = this.modalService.open(RangeDatePickerComponent, { size: 'lg', centered: true });
    modalRef.componentInstance.initialFromDate = this.filterForm.value.created_datefrom;
    modalRef.componentInstance.initialToDate = this.filterForm.value.created_dateupto;

    modalRef.result.then((result) => {
      if (result?.fromDate && result?.toDate) {
        this.filterForm.patchValue({
          created_datefrom: result.fromDate,
          created_dateupto: result.toDate
        });
        this.displayRangeText = dayjs(result.fromDate).format('DD-MM-YYYY') + ' - ' + dayjs(result.toDate).format('DD-MM-YYYY');
        this.onChangeApplyFilter();
      }
    }, () => { });
  }

  getDealers() {
    this.dealersService.getDealerDetails(this.dealerObj).subscribe((res: any) => {
      let data = res.data || [];
      if (this.dealerObj.page === 0) {
        this.dealerList = data;
      } else {
        this.dealerList = [...this.dealerList, ...data]
      }
    })
  }

  scrollDealer() {
    this.dealerObj.page++
    this.getDealers()
  }

  onDealerInputChange(event: any) {
    this.dealerObj.page = 0;
    this.dealerList = [];
    let delearSearch = event.term;
    this.dealerObj.searchTerm = delearSearch
    this.getDealers();
  }

  onDealerClose() {
    if (this.dealerObj.searchTerm) {
      this.dealerObj.page = 0;
      this.dealerObj.searchTerm = '';
      this.getDealers();
    }
  }

  onCustomerClose() {
    this.customers = [];
  }


  getAllUsers() {
    this.sdexAdminService.getAllUsers(this.usersObj).subscribe({
      next: (res: any) => {
        if (this.usersObj.page === 0) {
          this.usersList = res?.data?.result || [];
        } else {
          this.usersList = [...this.usersList, ...(res?.data?.result || [])]
        }
      }
    });
  }

  scroolUsers() {
    this.usersObj.page++
    this.getAllUsers();
  }

  getCustomers(payload: any) {
    this.customerLoading = true;
    this.stockService.getPhoneDetails(payload).subscribe({
      next: (res: any) => {
        this.customers = res.data ? [...this.customers, ...res.data] : this.customers;
        this.customerLoading = false;
      },
      error: () => {
        this.customerLoading = false;
      }
    })
  }

  onCustomerInputChange(event: any) {
    this.customers = [];
    let phone = event.term;
    if (phone) {
      this.customerObj.phoneNumber = phone;
      this.customerObj.page = 0;
      this.getCustomers(this.customerObj);
    }
  }

  scroollCustomer() {
    this.customerObj.page++
    this.getCustomers(this.customerObj);
  }

  closeToster() {
    this.errorMessage = '';
  }

  trackById(index: number, item: any) {
    return item ? item._id : index;
  }

  openDealerSummary(model: any, row: any) {
    if (!row.dealerId || !row.partner) return;
    this.activeDealerId = row.dealerId;
    this.dealerHighlights = { 
      dealer: row.partner, 
      loader: true, 
      displayRangeText: 'All'
    };
    this.modalService.open(model, { size: 'lg', centered: true, backdrop: 'static', keyboard: false });
    this.fetchDealerSummary();
  }


  openPerformance() {
    if (this.tablePayload.tyreSize && this.tablePayload.tyreMake &&
      this.tablePayload.tyreModel && this.isFilterApplied) {
      this.showPerformanceScreen = true;
    }
  }

}